import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e069c9c")

_pushScopeId("data-v-6e069c9c")
const _hoisted_1 = { class: "dialog-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_custom_input = _resolveComponent("custom-input")
  const _component_custom_form_item = _resolveComponent("custom-form-item")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_transfer = _resolveComponent("el-transfer")
  const _component_custom_form = _resolveComponent("custom-form")
  const _component_custom_button = _resolveComponent("custom-button")
  const _component_custom_dialog = _resolveComponent("custom-dialog")

  return (_openBlock(), _createBlock(_component_custom_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogVisible = $event)),
    title: _ctx.props.type==='add'?_ctx.$wordList.NewSubDistributor:_ctx.$wordList.EditSubDistributor,
    width: "40%"
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_1, [
        (_ctx.props.type==='edit')
          ? (_openBlock(), _createBlock(_component_custom_button, {
              key: 0,
              onClick: _ctx.resetPwd
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelResetPwTitle), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_custom_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogVisible=false))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_custom_button, {
          type: "primary",
          onClick: _ctx.submit
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_custom_form, {
        ref: "formRef",
        "label-position": "top",
        rules: _ctx.rules,
        model: _ctx.formData
      }, {
        default: _withId(() => [
          _createVNode(_component_custom_form_item, {
            label: _ctx.$wordList.TabelResetPwInHtmlAccount,
            prop: "Account"
          }, {
            default: _withId(() => [
              _createVNode(_component_custom_input, {
                disabled: _ctx.props.type==='edit',
                modelValue: _ctx.formData.Account,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Account = $event)),
                maxlength: "15"
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_custom_form_item, {
            label: _ctx.$wordList.TabelUserInHtmlCompany,
            prop: "Company"
          }, {
            default: _withId(() => [
              _createVNode(_component_custom_input, {
                modelValue: _ctx.formData.Company,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Company = $event)),
                maxlength: "15"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_custom_form_item, {
            label: _ctx.$wordList.TabelPropertyManageEmail,
            prop: "Email"
          }, {
            default: _withId(() => [
              _createVNode(_component_custom_input, {
                modelValue: _ctx.formData.Email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.Email = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_custom_form_item, {
            label: _ctx.$wordList.ProperAllTextMobileNumber,
            prop: "Phone"
          }, {
            default: _withId(() => [
              _createVNode(_component_custom_input, {
                modelValue: _ctx.formData.Phone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.Phone = $event)),
                maxlength: "15"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_custom_form_item, {
            label: _ctx.$wordList.PayBySubDistributor,
            prop: "PayBySubDis"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.formData.PayBySubDis,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.PayBySubDis = $event)),
                "active-color": "#13ce66",
                "inactive-color": "#DCDFE6",
                "active-value": "1",
                "inactive-value": "0"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_custom_form_item, {
            label: _ctx.$wordList.AssociateExistingInstallerAccounts,
            prop: "Phone"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_transfer, {
                modelValue: _ctx.formData.InstallerUUIDs,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.InstallerUUIDs = $event)),
                "button-texts": [_ctx.$wordList.ProperAllTextRemove,_ctx.$wordList.FormAdd],
                titles: [_ctx.$wordList.ProperAllTextToBeSelected, _ctx.$wordList.ProperAllTextSelected],
                data: _ctx.allowInstaller,
                props: {
                        key: 'UUID',
                        label: 'Account',
                    }
              }, null, 8, ["modelValue", "button-texts", "titles", "data"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
})